import { render } from "./MovementDetection.vue?vue&type=template&id=28fa1d06"
import script from "./MovementDetection.vue?vue&type=script&lang=js"
export * from "./MovementDetection.vue?vue&type=script&lang=js"

import "./MovementDetection.vue?vue&type=style&index=0&id=28fa1d06&lang=scss&scope=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__